import SectionTitle from './section-title';
import Photo from './photo';

export default function ContentBlock({ settings }) {
    settings.type = 'hero';
    return (
        <>
            {settings.type === 'text-block' && (
                <section key={'content-' + settings.id}>
                    <div className="container">
                        <SectionTitle
                            title={settings.title}
                            style="text-trust"
                            className="mt-10"
                        ></SectionTitle>
                    </div>
                    <div className="relative">
                        <div
                            className="container content"
                            dangerouslySetInnerHTML={{ __html: settings.content }}
                        ></div>
                    </div>
                </section>
            )}
            {settings.type == 'hero' && (
                <section key={'content-' + settings.id} className="container">
                    <div className="bg-maturity-50 bg-opacity-50 relative pt-24 pb-8 text-justify text-md">
                        <div className="skew-top"></div>
                        <div className="container">
                            <div className="flex flex-col p-20">
                                <span
                                    className="text-trust-900 text-3xl normal-case py-8 text-justify text-md"
                                    dangerouslySetInnerHTML={{ __html: settings.title }}
                                ></span>
                                <div
                                    className=" pb-10 text-justify text-md"
                                    dangerouslySetInnerHTML={{ __html: settings.content }}
                                ></div>
                            </div>
                        </div>
                        <div className="skew-bottom"></div>
                    </div>
                </section>
            )}
        </>
    );
}
